<template>
    <ScreenOverlay v-if="show">
        <div class="flex flex-col items-center justify-center gap-4">
            <Icon
                name="loading-spinner"
                class="animate-spin w-10 h-10 text-white"
            />
            <div class="text-white text-3xl font-semibold px-4 text-center">
                Scheduling your meeting, please wait...
            </div>
        </div>
    </ScreenOverlay>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'
    import ScreenOverlay from '@/Shared/Component/ScreenOverlay.vue'

    const props = defineProps({
        show: {
            type: Boolean,
            required: true,
        },
    })
</script>
